/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'map': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M29.365 18.19c0 .955-.317 1.96-.788 2.928-1.776 2.758-4.023 5.288-4.023 5.288s-2.584-2.442-4.235-5.338c-.414-.904-.684-1.86-.684-2.818 0-2.692 2.177-5.031 4.865-5.031 2.687 0 4.865 2.278 4.865 4.971zm-2.706-.157a2.142 2.142 0 1 0-4.284 0 2.142 2.142 0 0 0 4.284 0z"/><path pid="1" d="M35.55 16.165a.995.995 0 0 0-.944-.084l-3.462 1.484c.008.135.02.269.02.406 0 .598-.094 1.226-.271 1.877L34 18.517v12.824l-5 2.143V23.471a52.816 52.816 0 0 1-2 2.607v7.405l-5-2.143v-5.213a29.79 29.79 0 0 1-2-2.468v7.681l-5 2.143V20.659l2.975-1.275a7.467 7.467 0 0 1-.141-1.354c0-.264.02-.525.05-.783l-4.278 1.833c-.368.158-.606.52-.606.92v15a1.001 1.001 0 0 0 1.394.919L21 33.088l6.649 2.84c.113.043.231.072.351.072s.238-.029.351-.072l7.043-3.009A.999.999 0 0 0 36 32V17c0-.336-.169-.649-.45-.835z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/map.js